import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './DefaultContactsLayout.css';

export interface IDefaultContactsLayoutProps {
  callbackButton?: React.ReactNode;
  contactsButton?: React.ReactNode;
  messageButton?: React.ReactNode;
  flatViewButton?: React.ReactNode;
  offerBookingButton?: React.ReactNode;
  wrap: boolean;
}

export const DefaultContactsLayout: React.FC<React.PropsWithChildren<IDefaultContactsLayoutProps>> = ({
  callbackButton,
  contactsButton,
  messageButton,
  flatViewButton,
  offerBookingButton,
  wrap,
}) => {
  return (
    <div className={styles['container']}>
      {contactsButton && (
        <div className={clsx(styles['buttons-row'], { [styles['buttons-row--wrap']]: wrap })}>
          <div className={styles['button']}>{contactsButton}</div>
          {messageButton}
        </div>
      )}
      <div className={clsx(styles['buttons-row'], { [styles['buttons-row--wrap']]: wrap })}>
        {/* TODO: В CD-235461 следующие две кнопки будут удалены отсюда. */}
        {flatViewButton && <div className={styles['button']}>{flatViewButton}</div>}
        {/* istanbul ignore next */ callbackButton && <div className={styles['button']}>{callbackButton}</div>}
        {offerBookingButton && <div className={styles['button']}>{offerBookingButton}</div>}
      </div>
    </div>
  );
};
